/**
 * Downloads a Blob as a file by creating a temporary anchor element.
 * Handles the full lifecycle: createObjectURL → click → revokeObjectURL → cleanup.
 *
 * @param {Blob} blob - The binary data to download.
 * @param {string} filename - The suggested filename for the download.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

/**
 * Downloads a file from a URL in the SAME tab via a temporary anchor click —
 * no new tab/window. The URL must serve a non-renderable response (e.g. a
 * signed blob-storage download of a zip), which the browser saves in place
 * without navigating away from the page.
 *
 * @param {string} url - The file URL to download.
 */
export function downloadFromUrl(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  // Ignored on cross-origin URLs (the blob response's own headers/type drive
  // the save), but harmless — and it keeps same-origin URLs downloading too.
  a.download = '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
